
	import { Component, Vue } from 'vue-property-decorator';
	import IResource from "@/IResource";

	@Component({
		components: {},
	})
	export default class StepConfirmation extends Vue {

		get mode() {
			return this.$store.state.mode;
		}

		get resource(): IResource {
			return this.$store.state.resource;
		}

		get formattedFromTime(): string {
			let minutes: string = String(this.$store.state.fromtime % 60);
			if (minutes.length == 1) {
				minutes = '0' + minutes;
			}
			return Math.floor(this.$store.state.fromtime / 60) + ':' + minutes;
		}

		get formattedToTime(): string {
			let minutes: string = String(this.$store.state.totime % 60);
			if (minutes.length == 1) {
				minutes = '0' + minutes;
			}
			return Math.floor(this.$store.state.totime / 60) + ':' + minutes;
		}

		public mounted() {
			this.$gtag.pageview( {page_path: '/step-confirmation' });
		}
	}
